import {Directive, EventEmitter, Injector, OnDestroy, OnInit} from "@angular/core";
import {BaseComponentDirective} from "./base.component";
import {PageInterface, PageQueryInterface} from "../../_models/page.interface";
import {DateHelper} from "../../_helpers/date.helper";

@Directive()
export abstract class BasePageComponentDirective<T> extends BaseComponentDirective implements OnInit, OnDestroy {
    protected page = new EventEmitter();
    public pageData: PageInterface;
    public pageNo = 0;
    public pageSize = 10;
    public showPages = 3;
    public totalRow = 0;
    public pageItems: T[] = [];
    public searchTerm = '';
    public sortBy = 'id';
    public sortOrder = 'asc';
    public columns: string[] = [];
    public filters: any = null;
    public tableLoading = true;

    public pageQuery: PageQueryInterface = {
        page: this.pageNo,
        size: this.pageSize,
        filters: null,
        search: '',
        sortBy: '',
        sortOrder: '',
        columns: []
    };

    protected constructor(injector: Injector) {
        super(injector);
    }

    override ngOnInit(): void {
        super.ngOnInit();
        this.page.subscribe((res) => {
            this.pageData = res;
            this.pageItems = this.pageData.content;
            this.totalRow = this.pageData.totalItems;
            this.pageNo = this.pageData.currentPage;
            this.tableLoading = false;
        });
    }

    public abstract query(): void;

    toPage(p: number): void {
        this.pageQuery = {
            page: p + 1,
            size: this.pageSize,
            search: this.searchTerm,
            sortBy: this.sortBy,
            columns: this.columns,
            filters: this.filters,
            sortOrder: this.sortOrder
        };
        this.query();
    }

    perPageSet(p: number) {
        this.pageSize = p;
        this.pageQuery = {
            page: 1,
            size: this.pageSize,
            search: this.searchTerm,
            sortBy: this.sortBy,
            columns: this.columns,
            filters: this.filters,
            sortOrder: this.sortOrder
        };
        this.query();
    }

    doSearch(searchTerm: string, $event: any): void {
        if ($event.key === 'Enter') {
            this.pageQuery = {
                page: 1,
                size: this.pageSize,
                search: this.searchTerm,
                sortBy: this.sortBy,
                columns: this.columns,
                filters: this.filters
            };
            this.query();
        }
    }

}
